function install(Vue, axios, enableGlobalAuth) {
  Vue.prototype.$calliaAxios = async props => {
    const tokens = await Vue.prototype.$auth.getTokens();
    props.headers = {
      ...props.headers,
      Authorization: `Bearer ${tokens.accessToken}`,
      "callia-lang": process.env.VUE_APP_PROJECT_CALLIA_LANG || "en-CA"
    };
    return await axios(props);
  };

  Vue.prototype.$axios = axios;

  if (enableGlobalAuth) {
    axios.interceptors.request.use(
      async function(config) {
        if (
          config.url &&
          config.url.startsWith(process.env.VUE_APP_API_ADMIN_API_ENDPOINT)
        ) {
          const tokens = await Vue.prototype.$auth.getTokens();
          config.headers["Authorization"] = `Bearer ${tokens.accessToken}`;
          config.headers["callia-lang"] =
            process.env.VUE_APP_PROJECT_CALLIA_LANG || "en-CA";
        }

        return config;
      },
      function(error) {
        return Promise.reject(error);
      }
    );
  }

  console.log("init-callia-axios");
}

export default { install };
